<template>
  <div>
    <AnswerField
      v-for="subfieldtype in fieldType.subfieldtypes"
      :key="subfieldtype.id"
      :userFormId="userFormId"
      :question="question"
      :fieldType="subfieldtype"
      :readOnly="readOnly || false"
    />
  </div>
</template>

<script>
import AnswerField from './AnswerField'

export default {
  name: 'CustomFieldType',
  props: ['userFormId', 'question', 'fieldType', 'readOnly'],
  components: {
    AnswerField
  }
}
</script>
